/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_KeyInputs */

const en_tables_custom_properties_key = /** @type {(inputs: Tables_Custom_Properties_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Key`)
};

const de_tables_custom_properties_key = /** @type {(inputs: Tables_Custom_Properties_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

/**
* | output |
* | --- |
* | "Properties Key" |
*
* @param {Tables_Custom_Properties_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_key = /** @type {((inputs?: Tables_Custom_Properties_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_key(inputs)
	return de_tables_custom_properties_key(inputs)
});